import { Button, ButtonVariant } from "components/Form/Button";
import { Modal } from "components/Modal";
import { memo } from "react";
import { AppRoutes } from "types";

interface ExitConfirmationModalProps {
  show: boolean;
  onClose: () => void;
}

export const ExitConfirmationModal = memo(function ExitConfirmationModal({
  show,
  onClose,
}: ExitConfirmationModalProps) {
  return (
    <Modal show={show} onClose={onClose}>
      <div className="text-center space-y-6 p-6">
        <div>
          <h2 className="text-20 font-semibold text-gray-900">
            Are you sure you want to exit?
          </h2>
          <p className="text-858494 mt-4">
            Your email won't be verified and you won't have a password. You'll
            need to repeat the process to contribute.
          </p>
        </div>

        <div className="space-y-3">
          <button
            type="button"
            onClick={onClose}
            className="w-full bg-blue-500 text-white py-3 px-4 rounded-lg font-medium hover:bg-blue-600 transition-colors flex items-center justify-center gap-2"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            Continue Setting Password
          </button>

          <Button
            variant={ButtonVariant.FLAT}
            to={AppRoutes.login}
            type="button"
            className="w-full bg-red-50 text-red-600 py-3 px-4 rounded-lg font-medium hover:bg-red-100 transition-colors flex items-center justify-center gap-2 border border-red-200"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
            Exit to Login
          </Button>

          <button
            type="button"
            onClick={onClose}
            className="w-full text-858494 py-2 font-medium hover:text-gray-900 transition-colors"
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
});
